<div class="table-config-dialog">
  <div class="dialog-header">
    <h2>{{ getTitle() }}</h2>
    <button class="close-btn" (click)="onCancel()">✕</button>
  </div>

  <form [formGroup]="form" class="dialog-body">
    <div class="form-group">
      <label for="number">Número de Mesa:</label>
      <input 
        id="number"
        type="number" 
        formControlName="number" 
        class="form-control"
        placeholder="Ej: 1, 2, 3...">
    </div>

    <div class="form-group">
      <label for="capacity">Capacidad:</label>
      <input 
        id="capacity"
        type="number" 
        formControlName="capacity" 
        class="form-control"
        min="1"
        max="20"
        placeholder="Ej: 4, 6, 8...">
    </div>

    <div class="form-group">
      <label for="zone">Zona:</label>
      <select formControlName="zoneId" class="form-control" id="zone">
        <option value="">-- Selecciona una zona --</option>
        <option *ngFor="let zone of zones" [value]="zone.id">
          {{ zone.name }}
        </option>
      </select>
    </div>

    <div class="form-group-row">
      <div class="form-group">
        <label for="positionX">Posición X (px):</label>
        <input 
          id="positionX"
          type="number" 
          formControlName="positionX" 
          class="form-control">
      </div>

      <div class="form-group">
        <label for="positionY">Posición Y (px):</label>
        <input 
          id="positionY"
          type="number" 
          formControlName="positionY" 
          class="form-control">
      </div>
    </div>

    <!-- Código QR de la mesa (solo en edición): el cliente escanea y ve estado del pedido -->
    <div *ngIf="mode === 'edit' && table" class="qr-section">
      <h3 class="qr-title">Código QR de la mesa</h3>
      <p class="qr-hint">Comparta este QR con el cliente solo cuando la mesa tenga un pedido activo (no facturado). Tras facturar, el código dejará de funcionar.</p>
      <div class="qr-wrap" *ngIf="qrDataUrl">
        <img [src]="qrDataUrl" alt="QR Mesa" class="qr-image" />
        <p class="qr-url">{{ tableStatusUrl }}</p>
      </div>
      <div *ngIf="mode === 'edit' && !qrDataUrl" class="qr-loading">Generando QR…</div>
    </div>
  </form>

  <div class="dialog-footer">
    <button class="btn btn-secondary" (click)="onCancel()">Cancelar</button>
    <button class="btn btn-primary" (click)="onSave()">Guardar</button>
  </div>
</div>
